import Http from '@/api/http/';

export default class AiQuota extends Http {
  constructor() {
    super();
  }

  /**
   * 获取配额列表
   * @param {string} params.uniqueId - 唯一id
   * @param {string} params.companyName - 公司名称
   * @param {integer} params.status - 状态：0 - 启用、2 - 禁用
   */
  aiQuota_getList() {
    return super.post('aiQuota/getList', ...arguments);
  }

  /**
   * 获取配额详情列表
   * @param {string} params.uniqueId - 唯一id
   * @param {integer} params.type - 类型：1、嗨探，2、巡店，3、数据平台
   */
  aiQuota_getSkillList() {
    return super.post('aiQuota/getSkillList', ...arguments);
  }

  /**
   * 更新平台能力列表
   * @param {string} params.uniqueId - 唯一id
   * @param {integer} params.type - 类型：1、嗨探，2、巡店，3、数据平台
   * @param {array} params.skillList - 能力列表
   */
  aiQuota_updateSkillList() {
    return super.post('aiQuota/updateSkillList', ...arguments);
  }

  /**
   * 获取配额信息
   * @param {string} params.uniqueId - 唯一id
   * @param {integer} params.type - 类型：1、嗨探，2、巡店，3、数据平台
   */
  aiQuota_getQuotaInfo() {
    return super.post('aiQuota/getQuotaInfo', ...arguments);
  }

  /**
   * 调整配额
   * @param {string} params.uniqueId - 唯一id
   * @param {integer} params.type - 类型：1、嗨探，2、巡店，3、数据平台
   * @param {integer} params.quotaType - 类型：1、购买额度，2、赠送额度，3、减少额度
   * @param {integer} params.quota - 额度
   * @param {string} params.remark - 备注
   */
  aiQuota_changeQuota() {
    return super.post('aiQuota/changeQuota', ...arguments);
  }

  /**
   * 获取配额调整日志列表
   * @param {string} params.uniqueId - 唯一id
   */
  aiQuota_getLogList() {
    return super.post('aiQuota/getLogList', ...arguments);
  }

  /**
   * 获取配额使用记录列表
   * @param {string} params.companyId - 公司id
   * @param {string} params.startTime - 开始时间
   * @param {string} params.endTime - 结束时间
   * @param {array} params.skillIds - 能力id列表
   */
  aiQuota_getAiQuotaRecordList() {
    return super.post('aiQuota/getAiQuotaRecordList', ...arguments);
  }

  /**
   * 导出配额使用记录
   * @param {string} params.companyId - 公司id
   * @param {string} params.startTime - 开始时间
   * @param {string} params.endTime - 结束时间
   * @param {array} params.skillIds - 能力id列表
   */
  aiQuota_export() {
    return super.post('aiQuota/export', ...arguments);
  }
}
